import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { SagaIterator } from 'redux-saga'
import { call, put, select, spawn } from 'redux-saga/effects'

import { AIInternalActions } from '../../actions'
import { stopChat } from '../../v2/chatAgentClient'
import { abortActiveChatStream } from './sendMessageV2'

function* notifyServerStop(projectId: string): SagaIterator {
  try {
    yield call(stopChat, projectId)
  } catch {
    // Best effort: the local stream is already aborted; the server will
    // also notice the closed connection.
  }
}

export function* stopMessageV2(): SagaIterator {
  const hadActiveStream = abortActiveChatStream()

  // Legacy /v2 generators (useGenerateProject etc.) listen to this event.
  window.dispatchEvent(new Event('CancelAiGeneration'))

  if (hadActiveStream) {
    const projectId = yield select(migrationProjectSelector.getProjectId)

    if (projectId) {
      // Fire-and-forget: do not block the UI on the stop round-trip.
      yield spawn(notifyServerStop, projectId)
    }
  }

  // The aborted sendMessageV2 saga performs its own cleanup; reset here as
  // well for instant UI feedback (mirrors the v1 stopMessage behaviour).
  yield put(AIInternalActions.resetGeneration())
}
